export const overlayTokens = {
    fonts: {
        base: '13px monospace',
        small: '12px monospace',
        detail: '11px monospace',
        tiny: '10px monospace',
    },
    colors: {
        panelFill: 'rgba(12,12,14,0.88)',
        panelStroke: 'rgba(255,255,255,0.15)',
        text: '#eaeaea',
        textMuted: '#b0b0b0',
        textActive: '#e9f5ee',
        buttonActiveFill: 'rgba(58,110,78,0.8)',
        buttonInactiveFill: 'rgba(30,30,32,0.7)',
        buttonDisabledFill: 'rgba(60,60,60,0.45)',
        buttonActiveStroke: 'rgba(255,255,255,0.35)',
        buttonInactiveStroke: 'rgba(255,255,255,0.2)',
        buttonDisabledStroke: 'rgba(255,255,255,0.15)',
        progressTrackFill: 'rgba(30,30,32,0.6)',
        progressTrackStroke: 'rgba(255,255,255,0.15)',
        progressFill: 'rgba(88,196,122,0.75)',
        badgeWarn: 'rgba(230,160,60,0.9)',
        badgeError: 'rgba(210,60,60,0.92)',
        warnFill: 'rgba(78,48,10,0.85)',
        warnStroke: 'rgba(255,210,140,0.35)',
        warnText: '#ffe0b8',
        errorFill: 'rgba(64,12,12,0.85)',
        errorStroke: 'rgba(255,180,180,0.3)',
        errorText: '#ffd6d6',
    },
    layout: {
        barPadding: 8,
        buttonPadX: 10,
        buttonHeight: 22,
        buttonGap: 6,
        barY: 12,
        infoPanel: { x: 12, yOffset: 10, w: 260, h: 60 },
        instructions: { x: 12, h: 24, w: 300, marginBottom: 36 },
        dismissible: {
            x: 12,
            width: 320,
            headerHeight: 22,
            itemHeight: 58,
            gap: 10,
        },
        alert: {
            width: 320,
            headerHeight: 22,
            itemHeight: 54,
            gap: 8,
        },
        progress: {
            height: 8,
            gapY: 40,
            paddingX: 8,
            rightInset: 48,
        },
        dismissButton: { w: 26, h: 16, insetX: 34, insetY: 8 },
        dismissAction: { w: 96, h: 16, insetX: 8, insetY: 34 },
    },
};
